import React, { Component } from 'react';
import {FusePageSimple} from '@fuse';
import { Card, CardContent, Paper, Table, TableBody, TableCell, TableHead, TableRow, Typography, withStyles } from '@material-ui/core';
import Dropzone from 'react-dropzone-uploader';
import Pagination from "material-ui-flat-pagination";
// import { Offline, Online } from "react-detect-offline";


import { bindActionCreators } from 'redux';
import { withRouter } from 'react-router-dom';
import { connect } from 'react-redux';
import * as Actions from 'store/actions';

const styles = theme => ({
    layoutRoot: {},
    header: {
        minHeight: '72px',
        maxHeight: '72px'
    }
});

const Layout = ({ input, previews, submitButton, dropzoneProps, files, extra: { maxFiles } }) => {
    return (
      <div className="unggah-hasil-supervisi">
        {previews}
  
        <div {...dropzoneProps}>
          {files.length < maxFiles && input}
        </div>
  
        {files.length > 0 && submitButton}
      </div>
    )
  }

class UnggahHasilSupervisi extends Component {
    state = {
        offset: 10,
        total: 0,
        files: [],
        log_import_os: [],
        filename_aktif: '',
        sekolah: {}
    }

    loadData = () => {

    }

    hashFnv32a = (str, asString, seed) => {
        /*jshint bitwise:false */
        var i, l,
            hval = (seed === undefined) ? 0x811c9dc5 : seed;
    
        for (i = 0, l = str.length; i < l; i++) {
            hval ^= str.charCodeAt(i);
            hval += (hval << 1) + (hval << 4) + (hval << 7) + (hval << 8) + (hval << 24);
        }
        if( asString ){
            // Convert to 8 digit hex string
            return ("0000000" + (hval >>> 0).toString(16)).substr(-8);
        }
        return hval >>> 0;
    }

    // getUploadParams = () => ({ url: 'https://httpbin.org/post' })

    handleSubmit = (files, allFiles) => {

        // console.log(files);
        this.props.setLoadingBesar(true);

        for (let index = 0; index < files.length; index++) {
            const element = files[index]

            // console.log(files)

            if(element.meta.size >= 2000000){ //2Mb
                alert('Ukuran file tidak boleh melebihi 2MB!')
                return true
            }

            if(element.meta.name.substr(element.meta.name.length - 3) === 'csv' || element.meta.name.substr(element.meta.name.length - 3) === 'eds'){
                // filenya sesuai oke

                return new Promise(
                    (resolve, reject) => {
                        const xhr = new XMLHttpRequest();
                        xhr.open('POST', localStorage.getItem('api_domain')+'/api/InstrumenEDS/uploadFileOfflineSurveys');
                        // xhr.open('POST', localStorage.getItem('api_domain') + '/api/UploadFileSupervisi');
                        xhr.onload = this.uploadBerhasil;
                        xhr.onerror = this.uploadGagal;
                        const data = new FormData();
                        data.append('berkas', files[index].file);
                        // data.append('guid', 'testing-guid');
                        // data.append('id', 'testing');
                        // data.append('jenis', 'testing_jenis');
                        xhr.send(data);

                        // for (let index = 0; index < files.length; index++) {
                        //     const element = files[index];
                            
                        //     this.handleSetFiles(element);
                        // }
                        allFiles.forEach(f => {
                            f.remove();
                        })
                    }
                );

            }else{
                alert('File tidak sesuai dengan ketentuan. Mohon ulangi lagi dengan memilih file yang sesuai!')
                return true;
            }
        }
        return true

        // console.log(files.map(f => f.meta))
        // for (let index = 0; index < files.length; index++) {
        //     const element = files[index];
            
        //     this.handleSetFiles(element);
        // }
        // allFiles.forEach(f => {
        //     f.remove();
        // })
    }

    uploadBerhasil = (xhr) => {
        console.log(JSON.parse(xhr.currentTarget.responseText));
        let response = JSON.parse(xhr.currentTarget.responseText);
        if(response.msg == 'sukses'){

            this.setState({
                ...this.state,
                filename_aktif: response.filename
            },()=>{

                // console.log(this.state.sekolah.bentuk_pendidikan_id)
                
                if(parseInt(this.state.sekolah.bentuk_pendidikan_id) === 29){

                    //sama semua
                    this.props.ProsesFileImport({filename: response.filename, sekolah_id: JSON.parse(localStorage.getItem('user')).sekolah_id }).then((result)=>{
                    
                        this.props.logImportOs({foo:'bar', sekolah_id: JSON.parse(localStorage.getItem('user')).sekolah_id}).then((result)=>{
                            this.setState({
                                log_import_os: result.payload
                            },()=>{
        
                                return new Promise(
                                    (resolve, reject) => {
                                        const xhr = new XMLHttpRequest();
                                        xhr.open('POST', localStorage.getItem('api_domain')+'/api/InstrumenEDS/hapusFileOfflineSurveys');
                                        // xhr.open('POST', localStorage.getItem('api_domain') + '/api/UploadFileSupervisi');
                                        // xhr.onload = this.uploadBerhasil;
                                        // xhr.onerror = this.uploadGagal;
                                        const data = new FormData();
                                        // data.append('berkas', files[index].file);
                                        data.append('filename', this.state.filename_aktif);
                                        // data.append('id', 'testing');
                                        // data.append('jenis', 'testing_jenis');
                                        xhr.send(data);
    
                                        this.props.setLoadingBesar(false);
                                    }
                                );
        
                            })
                        })
        
                    })

                }else{
                    
                    //start of pengecekan originalitas
                    this.props.CekFileImport({filename: response.filename, sekolah_id: JSON.parse(localStorage.getItem('user')).sekolah_id }).then((result)=>{
    
                        console.log(result.payload.cek_1);
                        // console.log(
                        //     result.payload.email + 
                        //     this.hashFnv32a( 
                        //         result.payload.npsn + 
                        //         result.payload.npsn, 
                        //         true 
                        //     ) 
                        // )
                        console.log(
                            this.hashFnv32a(
                                result.payload.email, 
                                true
                            )+
                            this.hashFnv32a(
                                result.payload.npsn+
                                this.hashFnv32a(
                                    result.payload.npsn, 
                                    true
                                ), 
                                true
                            )
                        );
                        // // console.log(this.hashFnv32a(result.payload.npsn, true)+this.hashFnv32a(result.payload.npsn+this.hashFnv32a(result.payload.npsn, true), true));
                        // console.log(result.payload.cek_2);
                        // // console.log(
                        // //     this.hashFnv32a( 
                        // //         result.payload.nuptk + 
                        // //         result.payload.npsn, 
                        // //         true 
                        // //     ) + 
                        // //     result.payload.nuptk
                        // // )
                        // console.log(
                        //     this.hashFnv32a(
                        //         result.payload.nuptk+
                        //         this.hashFnv32a(
                        //             result.payload.npsn, 
                        //             true
                        //         ), 
                        //         true
                        //     )+
                        //     this.hashFnv32a(
                        //         result.payload.nuptk, 
                        //         true
                        //     )
                        // );
                        // // console.log(this.hashFnv32a(result.payload.nuptk, true)+this.hashFnv32a(result.payload.npsn+this.hashFnv32a(result.payload.nuptk, true), true));
                        // // console.log(this.hashFnv32a(result.payload.nuptk, true)+this.hashFnv32a(result.payload.nuptk+this.hashFnv32a(result.payload.nuptk, true), true));
                        // return true;
    
                        let cek_1 = this.hashFnv32a(
                            result.payload.email, 
                            true
                        )+
                        this.hashFnv32a(
                            result.payload.npsn+
                            this.hashFnv32a(
                                result.payload.npsn, 
                                true
                            ), 
                            true
                        )
    
                        if(result.payload.cek_1 === cek_1){
                            // if(result.payload.cek_2 === this.hashFnv32a(result.payload.nuptk, true)+this.hashFnv32a(result.payload.nuptk+this.hashFnv32a(result.payload.nuptk, true), true)){
                                
                                //sama semua
                                this.props.ProsesFileImport({filename: response.filename, sekolah_id: JSON.parse(localStorage.getItem('user')).sekolah_id }).then((result)=>{
                    
                                    this.props.logImportOs({foo:'bar', sekolah_id: JSON.parse(localStorage.getItem('user')).sekolah_id}).then((result)=>{
                                        this.setState({
                                            log_import_os: result.payload
                                        },()=>{
                    
                                            return new Promise(
                                                (resolve, reject) => {
                                                    const xhr = new XMLHttpRequest();
                                                    xhr.open('POST', localStorage.getItem('api_domain')+'/api/InstrumenEDS/hapusFileOfflineSurveys');
                                                    // xhr.open('POST', localStorage.getItem('api_domain') + '/api/UploadFileSupervisi');
                                                    // xhr.onload = this.uploadBerhasil;
                                                    // xhr.onerror = this.uploadGagal;
                                                    const data = new FormData();
                                                    // data.append('berkas', files[index].file);
                                                    data.append('filename', this.state.filename_aktif);
                                                    // data.append('id', 'testing');
                                                    // data.append('jenis', 'testing_jenis');
                                                    xhr.send(data);
                
                                                    this.props.setLoadingBesar(false);
                                                }
                                            );
                    
                                        })
                                    })
                    
                                })
    
                            // }else{
                            //     //nggak sama
                            //     alert("nuptk " + result.payload.cek_2 + " = " + this.hashFnv32a(result.payload.nuptk, true)+this.hashFnv32a(result.payload.nuptk+this.hashFnv32a(result.payload.nuptk, true), true))
                            //     // alert('File terindikasi telah dimodifikasi. Mohon ulangi upload file dengan file yang lain!')
    
                            //     return new Promise(
                            //         (resolve, reject) => {
                            //             const xhr = new XMLHttpRequest();
                            //             xhr.open('POST', localStorage.getItem('api_domain')+'/api/InstrumenEDS/hapusFileOfflineSurveys');
                            //             // xhr.open('POST', localStorage.getItem('api_domain') + '/api/UploadFileSupervisi');
                            //             // xhr.onload = this.uploadBerhasil;
                            //             // xhr.onerror = this.uploadGagal;
                            //             const data = new FormData();
                            //             // data.append('berkas', files[index].file);
                            //             data.append('filename', this.state.filename_aktif);
                            //             // data.append('id', 'testing');
                            //             // data.append('jenis', 'testing_jenis');
                            //             xhr.send(data);
    
                            //             this.props.setLoadingBesar(false);
                            //         }
                            //     );
                            // }
                        }else{
                            //nggak sama
                            // alert("npsn " + result.payload.cek_1 + " = " + cek_1)
                            alert('File terindikasi telah dimodifikasi. Mohon ulangi upload file dengan file yang lain!')
                            
                            return new Promise(
                                (resolve, reject) => {
                                    const xhr = new XMLHttpRequest();
                                    xhr.open('POST', localStorage.getItem('api_domain')+'/api/InstrumenEDS/hapusFileOfflineSurveys');
                                    // xhr.open('POST', localStorage.getItem('api_domain') + '/api/UploadFileSupervisi');
                                    // xhr.onload = this.uploadBerhasil;
                                    // xhr.onerror = this.uploadGagal;
                                    const data = new FormData();
                                    // data.append('berkas', files[index].file);
                                    data.append('filename', this.state.filename_aktif);
                                    // data.append('id', 'testing');
                                    // data.append('jenis', 'testing_jenis');
                                    xhr.send(data);
    
                                    this.props.setLoadingBesar(false);
                                }
                            );
                        }
    
                        // console.log(result)
                        
                        // console.log("hash_ori_1 = "+result.payload.cek_1)
                        // console.log("hash_cek_1 = "+this.hashFnv32a(result.payload.npsn, true)+this.hashFnv32a(result.payload.npsn+this.hashFnv32a(result.payload.npsn, true), true))
                        
                        // console.log("hash_ori_2 = "+result.payload.cek_2)
                        // console.log("hash_cek_2 = "+this.hashFnv32a(result.payload.nuptk, true)+this.hashFnv32a(result.payload.nuptk+this.hashFnv32a(result.payload.nuptk, true), true))
                        
                        // console.log("npsn "+this.hashFnv32a(result.payload.npsn, true))
                        // console.log("nuptk "+this.hashFnv32a(result.payload.nuptk, true))
                        // console.log("email "+this.hashFnv32a(result.payload.email, true))
                        // console.log("jenis "+this.hashFnv32a(result.payload.jenis, true))
                        // console.log("ids "+this.hashFnv32a(result.payload.ids, true))
                        
    
                    })
                    
                }

                

                //end of pengecekan originalitas

            })
            

            // let arrBerkas = {
            //     berkas_calon_id: null,
            //     calon_peserta_didik_id: this.state.routeParams.calon_peserta_didik_id,
            //     jenis_berkas_id: response.jenis_berkas_id,
            //     nama_file: response.filename,
            //     keterangan: ''
            // };

            // this.setState({
            //     [response.jenis]: response.filename,
            //     loading: false,
            //     berkas_calon: [
            //         ...this.state.berkas_calon,
            //         arrBerkas
            //     ]
            // },()=>{
            //     console.log(this.state);
            // });

        }
    }

    uploadGagal = (xhr) => {
        // this.$f7.dialog.alert('Ada kesalahan pada sistem atau jaringan Anda, mohon cek kembali sebelum melakukan upload ulang', 'Mohon maaf');
        alert('Ada kesalahan pada sistem atau jaringan Anda, mohon cek kembali sebelum melakukan upload ulang')
    }

    handleSetFiles = (element) => {
        // console.log("UnggahHasilSupervisi -> handleSetFiles -> element", element)
        const time = new Date();
        const data = {
            tanggal: time.getFullYear() + '-' + time.getMonth() + '-' + time.getDate(),
            name: element.meta.name,
            peran: 'Kepala Sekolah',
            status: 'success',
        }

        let local = this.state.files;
        local[this.state.files.length] = data,

        this.setState({
            files: local
        });
    }

    componentDidMount = () => {
        this.props.setLoadingBesar(true)

        this.props.setJudul('Upload Hasil Pengisian Instrumen')

        this.props.logImportOs({foo:'bar',sekolah_id: JSON.parse(localStorage.getItem('user')).sekolah_id}).then((result)=>{
            this.setState({
                log_import_os: result.payload
            },()=>{

                this.props.getSekolah({sekolah_id: JSON.parse(localStorage.getItem('user')).sekolah_id}).then((result)=>{
                    this.setState({
                        sekolah: result.payload
                    },()=>{

                    })
                })

                this.props.setLoadingBesar(false)
            })
        })
    }

    render()
    {
        const {classes} = this.props;
        const { files } = this.state;
        console.log("UnggahHasilSupervisi -> files", files)

        return (
            <FusePageSimple
                classes={{
                    root: classes.layoutRoot,
                    header: classes.header
                }}
                header={
                    <div className="p-24"><h3>Import Hasil Pengisian Instrumen EDS menggunakan Aplikasi Mobile</h3></div>
                }
                content={
                    <div className="kontenUtama m-16 p-16" ref={div => (this.div = div)} onScroll={()=>{console.log('tes')}}>
                            
                            {/* <Dialog aria-labelledby="simple-dialog-title" open={this.state.loading_dialog}>
                                <DialogTitle id="simple-dialog-title">Set backup account</DialogTitle>
                                <List>
                                    {emails.map((email) => (
                                    <ListItem button onClick={() => handleListItemClick(email)} key={email}>
                                        <ListItemAvatar>
                                        <Avatar className={classes.avatar}>
                                            <PersonIcon />
                                        </Avatar>
                                        </ListItemAvatar>
                                        <ListItemText primary={email} />
                                    </ListItem>
                                    ))}

                                    <ListItem autoFocus button onClick={() => handleListItemClick('addAccount')}>
                                    <ListItemAvatar>
                                        <Avatar>
                                        <AddIcon />
                                        </Avatar>
                                    </ListItemAvatar>
                                    <ListItemText primary="Add account" />
                                    </ListItem>
                                </List>
                                </Dialog> */}
                            {/* <Offline>
                                Mohon maaf, fitur ini hanya tersedia ketika komputer Anda sedang dalam keadaan online. Silakan koneksikan komputer Anda dengan jaringan internet dan coba kembali
                            </Offline>
                            <Online> */}
                                <Card className="mb-16">
                                    <CardContent>
                                        <div className="dropzone-unggah-hasil-supervisi">
                                            <Dropzone
                                                // getUploadParams={this.getUploadParams}
                                                LayoutComponent={Layout}
                                                onSubmit={this.handleSubmit}
                                                inputContent="Upload File hasil pengisian dari Offline Surveys"
                                            />
                                        </div>
                                    </CardContent>
                                </Card>
                                {/* {this.hashFnv32a('string_testing', true)} */}
                                <Card className="mb-16">
                                    <CardContent>
                                        <div className="mb-8">
                                            <Typography variant="title">Riwayat Upload File Hasil Pengisian dari Offline Surveys</Typography>
                                        </div>
                                        <Paper className="p-8">
                                            <div className="table-responsive">
                                                <Table>
                                                    <TableHead>
                                                        <TableRow>
                                                            <TableCell>No</TableCell>
                                                            <TableCell>Tanggal</TableCell>
                                                            <TableCell>Nama</TableCell>
                                                            <TableCell>Peran</TableCell>
                                                            <TableCell>Status Proses</TableCell>
                                                            <TableCell>Keterangan Proses</TableCell>
                                                            {/* <TableCell>Jawaban dari File</TableCell> */}
                                                            {/* <TableCell>Jawaban terimpor</TableCell> */}
                                                        </TableRow>
                                                    </TableHead>
                                                    <TableBody>
                                                        {
                                                            this.state.log_import_os.map((n, key) =>
                                                                <TableRow key={key}>
                                                                    <TableCell>{ key + 1 }</TableCell>
                                                                    <TableCell>{ n.tanggal }</TableCell>
                                                                    <TableCell>{ n.nama_pengguna }</TableCell>
                                                                    <TableCell>{ n.peran }</TableCell>
                                                                    <TableCell style={{textAlign:'center', fontSize:'20px'}}>{ parseInt(n.jawaban_berhasil) > 0 ? '✅' : '❌'}</TableCell>
                                                                    <TableCell>{ parseInt(n.jawaban_berhasil) > 0 ? 'Berhasil' : 'Gagal - Responden tidak ditemukan' }</TableCell>
                                                                    {/* <TableCell>{ n.csv_berhasil }</TableCell>
                                                                    <TableCell>{ n.jawaban_berhasil }</TableCell> */}
                                                                </TableRow>   
                                                            )
                                                        }
                                                    </TableBody>
                                                </Table>
                                            </div>
                                            {/* <Pagination
                                                limit={20}
                                                offset={this.state.offset}
                                                total={this.state.total}
                                                innerButtonCount={1}
                                                style={{width: '100%'}}
                                                onClick={this.loadData}
                                            /> */}
                                        </Paper>
                                    </CardContent>
                                </Card>
                            {/* </Online> */}
                    </div>
                }
            />
        )
    }
}

function mapDispatchToProps(dispatch) {
    return bindActionCreators({
        setJudul: Actions.setJudul,
        setLoadingBesar: Actions.setLoadingBesar,
        ProsesFileImport: Actions.ProsesFileImport,
        CekFileImport: Actions.CekFileImport,
        getSekolah: Actions.getSekolah,
        logImportOs: Actions.logImportOs
    }, dispatch);
}

function mapStateToProps({ Instrumen, Sekolah, App }) {

    return {
        loading_besar: App.loading_besar
    }
}

export default withStyles(styles, { withTheme: true })(withRouter(connect(mapStateToProps, mapDispatchToProps)(UnggahHasilSupervisi)));



// WEBPACK FOOTER //
// ./src/main/content/Instrumen/UnggahHasilSupervisi.js